<script lang="ts">
  import type { StoresKey } from "~/stores";
  import { getStoresContext } from "~/stores";

  export let floor: string = '';
  export let showIcon: boolean = false;
  export let iconSrc: string = '';
  export let request_store_key: StoresKey;
  export let styles: {
    padding?: string;
    borderRadius?: string;
    backgroundColor?: string;
  } = {};

  const stores_context = getStoresContext(request_store_key);
  const { T } = stores_context;
  $: t = $T;
</script>

<div class="store-floor-container">
  <div class="wrapper">
    {#if showIcon && iconSrc}
      <div class="image-wrapper">
        <img src={iconSrc} alt="Floor icon" />
      </div>
    {/if}
    <p 
      class="floor-text"
      style="
        {styles.padding ? `padding: ${styles.padding};` : ''}
        {styles.borderRadius ? `border-radius: ${styles.borderRadius};` : ''}
        {styles.backgroundColor ? `background: ${styles.backgroundColor};` : ''}
      "
    >
      {t('common.floor')} {floor}
    </p>
  </div>
</div>

<style lang="scss">
  .store-floor-container {
    display: flex;
    align-items: center;
  }

  .wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .image-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .floor-text {
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: 1.2;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    margin: 0;
    padding: 0 6px;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
  }
</style> 